// [F-COOKIECMP] Career miniapp — cookie-consent állapotkezelés (Consent Mode v2).
//
// Az állapot forrása a window.__CAREER_CONSENT__, amit az SSR consent-bootstrap
// (career.tpl) tölt fel a career_consent_v1 cookie szigorú validálásával — a React
// oldalon NINCS második cookie-parser. A mentés (saveConsent) sorrendje kötött:
//   1. cookie írás
//   2. window.__CAREER_CONSENT__ frissítés (a trackerek guardjai ebből olvasnak)
//   3. gtag('consent','update') + dataLayer event
//   4. Meta Pixel átmenet-kezelés (betöltés / grant+PageView / revoke)
//
// Meta Pixel elv: hozzájárulás előtt a fbevents.js be sem töltődik (nulla hálózati
// kérés). Valódi t:0|nincs-döntés → t:1 átmenetkor a loader injektálja a stubot,
// init-el, grant-ol, és PONTOSAN EGY PageView-t küld az aktuális route-ra. A loader
// idempotens: meglévő window.fbq esetén a script/init kimarad, de a grant + PageView
// a valódi átmenetnél ilyenkor is megtörténik (re-grant eset). t:1 → t:1 mentés
// nem küld semmit.
export const CONSENT_COOKIE_NAME = 'career_consent_v1';
const CONSENT_COOKIE_DAYS = 365;
const OPEN_EVENT = 'career:consent-open';
// [F-TIKTOKPIXEL] a mentett döntés érvényesítése UTÁN kiváltott esemény (a pixel-átmenetek,
// azaz a betöltés + page() már megtörtént) — a route-szintű tracking hook ebből pótolja az
// aktuálisan megjelenített állás ViewContent eseményét, ha az elfogadás az állásoldalon történt.
const CHANGED_EVENT = 'career:consent-changed';
// Meta loader/init modul-szintű őre: SSR-init (tárolt t=1) esetén a window.fbq
// létezése jelzi az initet; mid-session betöltésnél ez a flag védi a dupla initet.
let metaPixelInitialized = false;
// [F-TIKTOKPIXEL] TikTok: melyik pixel-ID-t töltöttük be MI (mid-session loader) ebben a
// munkamenetben. Az SSR-betöltést (tárolt t=1) a window.ttq._i[pixelId] jelzi; ha ezt
// NEM mi hoztuk létre (pl. GTM custom HTML tag ugyanazzal az ID-vel), akkor a pixelnek
// más a gazdája: nem töltünk újra és page()-et sem küldünk, csak a consent-metódusokat hívjuk.
let tiktokLoadedPixelId = '';
const UNDECIDED = { decided: false, p: 0, t: 0, f: 0 };
export function getConsentState() {
    if (typeof window === 'undefined')
        return UNDECIDED;
    const state = window.__CAREER_CONSENT__;
    if (state && typeof state.decided === 'boolean') {
        return { decided: state.decided, p: state.p, t: state.t, f: state.f };
    }
    return UNDECIDED;
}
function writeConsentCookie(p, t, f) {
    if (typeof document === 'undefined')
        return;
    const payload = JSON.stringify({ v: 1, p, t, f });
    const maxAge = CONSENT_COOKIE_DAYS * 24 * 60 * 60;
    const segments = [
        CONSENT_COOKIE_NAME + '=' + encodeURIComponent(payload),
        'Max-Age=' + maxAge,
        'Path=/',
        'SameSite=Lax',
    ];
    // Host-only cookie (nincs Domain attribútum) — tenant-domain izoláció.
    if (typeof location !== 'undefined' && location.protocol === 'https:') {
        segments.push('Secure');
    }
    document.cookie = segments.join('; ');
}
function gtagConsentUpdate(p, t, f) {
    if (typeof window === 'undefined' || typeof window.gtag !== 'function')
        return;
    try {
        window.gtag('consent', 'update', {
            ad_storage: t === 1 ? 'granted' : 'denied',
            ad_user_data: t === 1 ? 'granted' : 'denied',
            ad_personalization: t === 1 ? 'granted' : 'denied',
            analytics_storage: p === 1 ? 'granted' : 'denied',
            functionality_storage: f === 1 ? 'granted' : 'denied',
            personalization_storage: f === 1 ? 'granted' : 'denied',
            security_storage: 'granted',
        });
    }
    catch (e) {
        // a consent-kezelés soha nem dobhat hibát az UI-nak
    }
}
function pushConsentDataLayerEvent(p, t, f) {
    if (typeof window === 'undefined')
        return;
    if (!window.dataLayer || !Array.isArray(window.dataLayer)) {
        window.dataLayer = [];
    }
    try {
        window.dataLayer.push({
            event: 'career_consent_update',
            consent_performance: p,
            consent_targeting: t,
            consent_functionality: f,
        });
    }
    catch (e) {
        // silent
    }
}
// Standard Meta Pixel stub + fbevents.js betöltés — a hivatalos snippet logikája,
// idempotens formában. Meglévő window.fbq esetén nem csinál semmit.
// Visszatérési érték: true, ha a stubot MOST MI hoztuk létre (ilyenkor kell init);
// false, ha az fbq már élt (banner-módban ez SSR-init-et jelent — career.tpl).
function loadMetaPixelScript() {
    if (typeof window === 'undefined' || typeof document === 'undefined')
        return false;
    if (window.fbq)
        return false;
    const fbq = function () {
        // eslint-disable-next-line prefer-rest-params
        fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
    };
    if (!window._fbq)
        window._fbq = fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    window.fbq = fbq;
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const first = document.getElementsByTagName('script')[0];
    if (first && first.parentNode) {
        first.parentNode.insertBefore(script, first);
    }
    else {
        document.head.appendChild(script);
    }
    return true;
}
// Valódi (t:0|nincs-döntés → t:1) átmenet: Pixel betöltés + init + grant + PONTOSAN
// EGY PageView az aktuális route-ra. Az SSR-initelt esetben (tárolt t=1 pageload,
// window.fbq már él) a loader/init skip-el, a grant + PageView viszont megy (re-grant).
function activateMetaPixel(pixelId) {
    if (typeof window === 'undefined' || !pixelId)
        return;
    try {
        const createdNow = loadMetaPixelScript();
        if (!window.fbq)
            return;
        if (!metaPixelInitialized) {
            // Ha az fbq már a mi loaderünk ELŐTT élt, azt az SSR init-elte (career.tpl,
            // tárolt t=1 pageload) — ilyenkor a dupla init kimarad, csak megjegyezzük.
            if (createdNow) {
                window.fbq('init', pixelId);
            }
            metaPixelInitialized = true;
        }
        window.fbq('consent', 'grant');
        window.fbq('track', 'PageView');
    }
    catch (e) {
        // silent
    }
}
function revokeMetaPixel() {
    if (typeof window === 'undefined' || typeof window.fbq !== 'function')
        return;
    try {
        window.fbq('consent', 'revoke');
    }
    catch (e) {
        // silent
    }
}
// [F-TIKTOKPIXEL] Az official TikTok Pixel stub (tömb-alapú queue + metódus-deferálás), a
// hivatalos snippet logikája idempotens formában. Meglévő window.ttq esetén nem csinál
// semmit. Visszatérés: true, ha a stubot MOST MI hoztuk létre.
function ensureTiktokStub() {
    if (typeof window === 'undefined' || typeof document === 'undefined')
        return false;
    const w = window;
    if (w.ttq)
        return false;
    const t = 'ttq';
    w.TiktokAnalyticsObject = t;
    const ttq = (w[t] = w[t] || []);
    ttq.methods = ['page', 'track', 'identify', 'instances', 'debug', 'on', 'off', 'once', 'ready',
        'alias', 'group', 'enableCookie', 'disableCookie', 'holdConsent', 'revokeConsent', 'grantConsent'];
    ttq.setAndDefer = function (target, method) {
        target[method] = function () {
            // eslint-disable-next-line prefer-rest-params
            target.push([method].concat(Array.prototype.slice.call(arguments, 0)));
        };
    };
    for (let i = 0; i < ttq.methods.length; i++)
        ttq.setAndDefer(ttq, ttq.methods[i]);
    ttq.instance = function (id) {
        const inst = ttq._i[id] || [];
        for (let n = 0; n < ttq.methods.length; n++)
            ttq.setAndDefer(inst, ttq.methods[n]);
        return inst;
    };
    ttq.load = function (id, options) {
        const url = 'https://analytics.tiktok.com/i18n/pixel/events.js';
        ttq._i = ttq._i || {};
        ttq._i[id] = [];
        ttq._i[id]._u = url;
        ttq._t = ttq._t || {};
        ttq._t[id] = +new Date();
        ttq._o = ttq._o || {};
        ttq._o[id] = options || {};
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = url + '?sdkid=' + id + '&lib=' + t;
        const first = document.getElementsByTagName('script')[0];
        if (first && first.parentNode) {
            first.parentNode.insertBefore(script, first);
        }
        else {
            document.head.appendChild(script);
        }
    };
    return true;
}
function isTiktokPixelLoaded(pixelId) {
    if (typeof window === 'undefined')
        return false;
    const ttq = window.ttq;
    return !!(ttq && ttq._i && Object.prototype.hasOwnProperty.call(ttq._i, pixelId));
}
// [F-TIKTOKPIXEL] Valódi (t:0|nincs-döntés -> t:1) átmenet. Három eset:
//  (a) a pixel még nincs betöltve: stub + ttq.load + grantConsent + PONTOSAN EGY ttq.page()
//      (a page-view gazdája a betöltő; a további SPA route-váltásokat az SDK méri);
//  (b) MI töltöttük be korábban (1 -> 0 -> 1 re-grant): grantConsent + pontosan egy page();
//  (c) más (SSR t=1 pageload vagy idegen tag, pl. GTM) töltötte be ugyanazt az ID-t: csak
//      grantConsent — nincs újratöltés és nincs page() (nem a mi gazdánk, dupla mérést kerülünk).
function activateTiktokPixel(pixelId) {
    if (typeof window === 'undefined' || !pixelId)
        return;
    try {
        const alreadyLoaded = isTiktokPixelLoaded(pixelId);
        const ownedByUs = tiktokLoadedPixelId === pixelId;
        if (!alreadyLoaded) {
            ensureTiktokStub();
            const ttq = window.ttq;
            if (!ttq || typeof ttq.load !== 'function')
                return;
            ttq.load(pixelId);
            tiktokLoadedPixelId = pixelId;
        }
        const ttq = window.ttq;
        if (!ttq)
            return;
        if (typeof ttq.grantConsent === 'function')
            ttq.grantConsent();
        if ((!alreadyLoaded || ownedByUs) && typeof ttq.page === 'function') {
            ttq.page();
        }
    }
    catch (e) {
        // silent
    }
}
function revokeTiktokPixel() {
    if (typeof window === 'undefined')
        return;
    const ttq = window.ttq;
    if (!ttq || typeof ttq.revokeConsent !== 'function')
        return;
    try {
        ttq.revokeConsent();
    }
    catch (e) {
        // silent
    }
}
/**
 * A látogató consent-döntésének mentése és azonnali érvényesítése.
 * Az "Összes elfogadása" = saveConsent(1,1,1, id), az "Összes elutasítása" =
 * saveConsent(0,0,0, id) — az all-zero is ÉRVÉNYES tárolt döntés (a banner nem
 * jelenik meg újra).
 */
export function saveConsent(p, t, f, fbPixelId, tiktokPixelId = '') {
    if (typeof window === 'undefined')
        return;
    const previous = getConsentState();
    // 1-2. perzisztálás + globális állapot — a trackerhívások guardjai előtt frissül
    writeConsentCookie(p, t, f);
    window.__CAREER_CONSENT__ = { decided: true, p, t, f };
    // 3. Google Consent Mode update + GTM-nek szánt explicit event
    gtagConsentUpdate(p, t, f);
    pushConsentDataLayerEvent(p, t, f);
    // 4. Meta + TikTok Pixel átmenet a MENTÉS ELŐTTI állapot alapján (t:1 -> t:1: semmi)
    if (t === 1 && previous.t !== 1) {
        activateMetaPixel(fbPixelId);
        activateTiktokPixel(tiktokPixelId);
    }
    else if (t === 0 && previous.t === 1) {
        revokeMetaPixel();
        revokeTiktokPixel();
    }
    // 5. Értesítés a feliratkozóknak (a pixelek már a mentett állapotban vannak)
    try {
        window.dispatchEvent(new CustomEvent(CHANGED_EVENT, { detail: { p, t, f } }));
    }
    catch (e) {
        // silent
    }
}
/**
 * Feliratkozás a consent-döntés mentésére (saveConsent után, a pixel-átmenetek UTÁN fut).
 */
export function subscribeConsentChange(callback) {
    if (typeof window === 'undefined')
        return () => undefined;
    window.addEventListener(CHANGED_EVENT, callback);
    return () => window.removeEventListener(CHANGED_EVENT, callback);
}
/**
 * Mehetnek-e hirdetési kattintás-azonosítók (gclid/fbclid) a jelentkezés
 * kérésébe. Legacy oldalon (nincs banner, __CAREER_CONSENT__ nem létezik) a
 * viselkedés változatlan (true); banner-módban KIZÁRÓLAG targeting-elfogadásnál
 * (t=1) — döntés nélkül vagy elutasításnál false. A szerveroldal ugyanezt a
 * szabályt kényszeríti ki (AdAttributionLib::careerAdConsentAllows).
 */
export function adClickIdsAllowed() {
    if (typeof window === 'undefined')
        return true;
    const state = window.__CAREER_CONSENT__;
    if (!state)
        return true;
    return state.t === 1;
}
/**
 * A banner újranyitása (pl. Footer "Cookie beállítások" link) — a CookieConsent
 * komponens App-szinten mountolva figyeli ezt az eseményt.
 */
export function openConsentSettings() {
    if (typeof window === 'undefined')
        return;
    window.dispatchEvent(new CustomEvent(OPEN_EVENT));
}
export function subscribeConsentOpen(callback) {
    if (typeof window === 'undefined')
        return () => undefined;
    window.addEventListener(OPEN_EVENT, callback);
    return () => window.removeEventListener(OPEN_EVENT, callback);
}
// Kizárólag tesztekhez: a modul-szintű Meta init-őr és a TikTok betöltés-őr visszaállítása.
export function __resetMetaPixelStateForTests() {
    metaPixelInitialized = false;
    tiktokLoadedPixelId = '';
}
